import { get, post, postfd } from '@/utils/request1';

export const aiOrderSubmit = (data) => postfd('ai/analyze',data); // ai自动填单